export default __webpack_public_path__ + "static/media/071.03e4e59f.jpg";